export default __webpack_public_path__ + "static/media/g2022-7.e287491e.jpeg";